import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const Dropzone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 150px;
  border: 2px dashed #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: height 0.2s ease;
  overflow: hidden;
`;

export const DropzoneActiveContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
`;

export const TextBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #616161;
  border-radius: 5px;
  padding: 10px;
  margin-top: 10px;
`;
